<template>
  <svg :class="svgClass" :style="svgStyle" aria-hidden="true">
    <use :href="symbolId" :xlink:href="symbolId" />
  </svg>
</template>

<script setup>
import { computed } from 'vue';
import { hasIcon } from '@icons';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value),
  },
  color: {
    type: String,
    default: '',
  },
  rotate: {
    type: Number,
    default: 0,
  },
  spin: {
    type: Boolean,
    default: false,
  },
});

if (process.env.NODE_ENV !== 'production' && !hasIcon(props.name)) {
  console.warn(
    `[PmIcon] symbol not in iconfont registry: "${props.name}". Run npm run sync:icons after CDN update.`
  );
}

const symbolId = computed(() => `#icon-${props.name}`);

const svgClass = computed(() => {
  const classes = ['pm-icon'];
  if (props.size) classes.push(`pm-icon-${props.size}`);
  if (props.spin) classes.push('pm-icon-spin');
  return classes;
});

const svgStyle = computed(() => {
  const styles = {};
  if (props.color) {
    styles.color = props.color;
    styles.fill = 'currentColor';
  }
  if (props.rotate && !props.spin) {
    styles.transform = `rotate(${props.rotate}deg)`;
  }
  return styles;
});
</script>

<style lang="scss" scoped>
.pm-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: -0.1em;
  flex-shrink: 0;
  font-size: 16px;
  transition: transform 0.2s ease;
  display: inline-block;
}

.pm-icon-sm,
.pm-icon-md {
  font-size: 16px;
}

.pm-icon-lg {
  font-size: 20px;
}

.pm-icon-xl {
  font-size: 24px;
}

.pm-icon-spin {
  animation: pm-icon-spin 1s linear infinite;
}

@keyframes pm-icon-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
